/**
 * A titled block on a long-form page (the privacy policy, support): one `<h2>`
 * via `aria-level` (each page owns exactly one `<h1>`, FR-019(e)) over the
 * page's own section gap. Shared so the two prose pages cannot drift apart in
 * heading semantics or rhythm.
 */

import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";
import { headingProps } from "@/lib/heading-props";
import { spacing } from "@/theme/tokens";

// Spread from constants per lib/heading-props.ts: `aria-level` is not in RN's
// prop types, and an inline attribute would be excess-property-checked.
const SECTION_HEADING_PROPS = headingProps(2);

export function PageSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <View style={styles.section}>
      <Text variant="titleLarge" {...SECTION_HEADING_PROPS}>
        {title}
      </Text>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    gap: spacing.sm,
  },
});
